
<div class="loading">

    <img src="assets/images/icon-fill.png" alt="" style="width: 80px" />
    <span class="mat-body-2" style="margin-top: 20px">
        Carregando conteúdo
    </span>

</div>